// src/context/FormContext.js
import React, { createContext, useContext } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

const FormContext = createContext();

export const TherapistFormProvider = ({ children, schema }) => {
  const methods = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <FormContext.Provider value={methods}>
      <FormProvider {...methods}>{children}</FormProvider>
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);
